import {
    CHAT_NO_SELECTED_CHAT_STORAGE_VALUE,
    CHAT_SELECTED_CHAT_STORAGE_KEY,
} from "../constants/chat";

export const normalizeSelectedChatId = (value) => {
    if (value === undefined || value === null) {
        return null;
    }
    const normalized = String(value).trim();
    return normalized || null;
};

export const readSelectedChatSelection = () => {
    if (typeof window === "undefined") {
        return {
            chatId: null,
            hasStoredSelection: false,
            isNoSelection: false,
        };
    }
    try {
        const raw = window.localStorage.getItem(CHAT_SELECTED_CHAT_STORAGE_KEY);
        if (raw === null) {
            return {
                chatId: null,
                hasStoredSelection: false,
                isNoSelection: false,
            };
        }
        if (raw === CHAT_NO_SELECTED_CHAT_STORAGE_VALUE) {
            return {
                chatId: null,
                hasStoredSelection: true,
                isNoSelection: true,
            };
        }
        return {
            chatId: normalizeSelectedChatId(raw),
            hasStoredSelection: true,
            isNoSelection: false,
        };
    } catch (error) {
        console.warn("Unable to restore selected chat", error);
        return {
            chatId: null,
            hasStoredSelection: false,
            isNoSelection: false,
        };
    }
};

export const persistSelectedChatSelection = (chatId) => {
    if (typeof window === "undefined") {
        return;
    }
    const normalizedChatId = normalizeSelectedChatId(chatId);
    try {
        window.localStorage.setItem(
            CHAT_SELECTED_CHAT_STORAGE_KEY,
            normalizedChatId || CHAT_NO_SELECTED_CHAT_STORAGE_VALUE
        );
    } catch (error) {
        console.warn("Unable to persist selected chat", error);
    }
};
